import { getEndpoint } from 'root/utils/cors/getEndpoint';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';

const doFetch = async <T>(
    url: string,
    errorLogObject?: {
        searchTerm: 'doFetch-error';
        tags: ['fetch', 'ui'];
        fileName: 'doFetch.ts';
    },
    callback?: (data: T, ...args: unknown[]) => unknown,
    errCallback?: (...args: unknown[]) => T | undefined,
    config?: RequestInit,
    callbackArgs: unknown[] = []
): Promise<T | undefined> => {
    try {
        const response = await fetch(getEndpoint(url), config);
        if (response.ok) {
            const data = (await response.json()) as T;
            if (callback) {
                const obj = typeof data === 'string' ? JSON.parse(data) : data;
                callback(obj, ...callbackArgs);
            }
            return data;
        } else {
            if (errCallback) {
                return errCallback(...callbackArgs);
            }
        }
    } catch (e) {
        LoggingHandler().logError(e, errorLogObject);
        if (errCallback) {
            return errCallback(...callbackArgs);
        }
    }
};

export default doFetch;
